import {AttributeTypeEnum} from "./components/bo-core/enums/AttributeTypeEnum";
import Utils from "./Utils";
import toastr from "toastr";
import axios from "axios";

export default class AgGridUtils {
    static readonly FILTER_REGEX = new RegExp(/((==)|(!=)|(=gt=)|(=ge=)|(=lt=)|(=le=)|(=re=)|(=nre=)|(=in=)|(=iin=)|(=out=)|(=iout=))\s?".*?"/g);

    static generateFilterData = (params: any): any => {
        const filter = {};
        const filterModel = params.request.filterModel;
        Object.keys(filterModel).map(key => {
            if (key !== "quickFilter") {
                const column = params.parentNode.gridApi.getColumnDef(key);
                if (column.dataType === AttributeTypeEnum.TIMESTAMP) {
                    filter[key] = filterModel[key].filter.replace(/\d{4}(-\d\d(-\d\d([T| ]\d\d:\d\d(:\d\d)?(\.\d+)?(([+-]\d\d:\d\d)|Z)?)?)?)?/g, function (a) {
                        if (Utils.moment(a, Utils.moment.ISO_8601).isValid()) {
                            const format: string = Utils.moment(a).creationData().format;
                            if (format === "YYYY-MM" || format === "YYYY-MM-DD") {
                                return a;
                            } else {
                                return Utils.localToUtc(a, format, format);
                            }
                        }
                        return a;
                    });
                } else {
                    filter[key] = filterModel[key].filter
                }
            }
        });
        return filter;
    };


    /**
     * Summary:
     * Method for generating filter data for the AG Grids.
     * * @modifiedColumns {Array}  - Optional parameter for boolean type column.
     * Example: [
     *     {
     *         column: 'access',
               values: {
                 allowed: true,
                 denied: false
               }
     *     }
     * ]
     */
    static generateFilterDataV2 = (params: any, modifiedColumns?: any): any => {
        let filter = '';
        const filterModel = params.request.filterModel;
        Object.keys(filterModel).forEach((key, index) => {
            if (key !== "quickFilter") {
                const column = params.parentNode.gridApi.getColumnDef(key);
                let content = filterModel[key].filter;

                if (modifiedColumns) {
                    const modifiedColumn = modifiedColumns.find(searchedColumn => searchedColumn.column === key);

                    if (modifiedColumn) {
                        if (modifiedColumn.values) {
                            Object.keys(modifiedColumn.values).forEach(colValue => {
                                content = content.toLowerCase();
                                content = content.replace(colValue, modifiedColumn.values[colValue])
                            })
                        }
                    }
                }

                const result = content.match(AgGridUtils.FILTER_REGEX);
                if (result) {
                    result.forEach(item => {
                        const searchedItemIndex = content.indexOf(item);
                        content = [content.slice(0, searchedItemIndex), column.field, content.slice(searchedItemIndex)].join('');
                    })

                    filter += content
                    if (index < Object.keys(filterModel).length - 1) {
                        filter += ' and '
                    }
                } else {
                    const column = params.parentNode.gridApi.getColumnDef(key);
                    if (column.dataType === AttributeTypeEnum.INT || column.dataType === AttributeTypeEnum.DECIMAL) {
                        content = [content.slice(0, 0), '==', content.slice(0)].join('');
                    } else {
                        content = [content.slice(0, 0), '=iin=', content.slice(0)].join('');
                    }
                    content = [content.slice(0, 0), column.field, content.slice(0)].join('');
                    filter += content
                    if (index < Object.keys(filterModel).length - 1) {
                        filter += ' and '
                    }
                }
            }
        });

        if (filter === '') {
            filter = ''
        } else {
            filter = [filter.slice(0, 0), 'filter=', filter.slice(0)].join('');
        }
        return filter;
    };

    static generateSortData = (sortModel: any): any => {
        const sort = {};
        sortModel.map(item => {
            sort[item.colId] = item.sort
        });
        return sort;
    };

    static deselectAllRows = (gridApi: any) => {
        if (gridApi) {
            gridApi.deselectAll();
        }
    }

    static serverSideErrorHandler = (e: any) => {
        if (e.response?.data?.message) {
            if (e.response.data.message.includes('Error parsing filter')) {
                toastr.error('Incorrect filter parameter. Click "?" icon to see filtration rules.');
            } else {
                toastr.error(e.response.data.message);
            }
        } else if (!axios.isCancel(e)) {
            toastr.error('Something went wrong');
        }
    }
}



// WEBPACK FOOTER //
// ./app/AgGridUtils.ts